<template >
    <div>
        <router-link
                     :to="'applications/'+row.id +'/details'"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm"
        >
            <div class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                <span class="tooltip-text">{{ $t('application.details') }}</span>
                <i class="fa fa-eye"></i>
            </div>
        </router-link>

</div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
    },
    methods : {
    },
})
</script>